"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const createConfig = (overrides) => {
    // eslint-disable-next-line no-underscore-dangle
    const data = overrides !== undefined ? overrides : window.__sbc_config;
    const getFromObject = (key, _data) => {
        if (!_data)
            return undefined;
        if (_data[key] !== undefined)
            return _data[key];
        const keys = key.split(".");
        if (keys.length === 1) {
            return _data[keys[0]];
        }
        const currentKey = keys[0];
        keys.shift();
        if (_data[currentKey] !== undefined) {
            return getFromObject(keys.join("."), _data[currentKey]);
        }
        const reverseKeys = key.split(".");
        const lastKeys = [];
        while (typeof _data[reverseKeys.join(".")] === "undefined" &&
            reverseKeys.length) {
            lastKeys.unshift(reverseKeys[reverseKeys.length - 1]);
            reverseKeys.pop();
        }
        if (_data[reverseKeys.join(".")] !== undefined)
            return getFromObject(lastKeys.join("."), _data[reverseKeys.join(".")]);
        return undefined;
    };
    const config = (key) => getFromObject(key, data);
    const getAppHref = (key, secondaryKey = "") => {
        const app = config(`ui.${key}`);
        if (app) {
            if (app.href)
                return app.href;
            if (secondaryKey && app[secondaryKey] && app[secondaryKey].href)
                return app[secondaryKey].href;
        }
        return undefined;
    };
    const getAppHrefByProductCode = (productCode, secondaryKey = "") => {
        const key = config(`productCodeMapping.${productCode}`);
        return key ? getAppHref(key, secondaryKey) : undefined;
    };
    const getApiBase = (key) => {
        const api = config(`api.${key}`);
        return api && api.href ? api.href : undefined;
    };
    const getStrippedHref = (href) => {
        const url = new URL(href);
        return url.hostname + url.pathname;
    };
    const getAllProductPaths = (productConfig) => {
        const hrefs = [productConfig.href];
        if (productConfig.aliases) {
            return hrefs.concat(productConfig.aliases);
        }
        return hrefs;
    };
    const getProductCodeByHref = (href) => {
        const uiEntries = config("ui");
        if (!uiEntries)
            return null;
        const uiKeys = Object.keys(uiEntries);
        const products = config(`productCodeMapping`);
        const productKeys = Object.keys(products);
        const strippedHref = getStrippedHref(href);
        let productCode = null;
        let closestMatchHref = null;
        uiKeys.forEach((uiKey) => {
            const uiHrefsFromConfig = uiEntries[uiKey].href
                ? getAllProductPaths(uiEntries[uiKey])
                : Object.keys(uiEntries[uiKey])
                    .filter((secondaryKey) => uiEntries[uiKey][secondaryKey].href || false)
                    .map((secondaryKey) => getAllProductPaths(uiEntries[uiKey][secondaryKey]))
                    .flat();
            uiHrefsFromConfig
                .map((uiHref) => getStrippedHref(uiHref))
                .filter((uiHref) => strippedHref.indexOf(uiHref) === 0)
                .forEach((uiHref) => {
                productKeys
                    .filter((productKey) => products[productKey] === uiKey)
                    .forEach((productKey) => {
                    if (!closestMatchHref || uiHref.indexOf(closestMatchHref) === 0) {
                        productCode = productKey;
                        closestMatchHref = uiHref;
                    }
                });
            });
        });
        return productCode;
    };
    const getRoute = (appName, key, isRelative) => {
        const targetAppName = config(`ui.${appName}.externalRoutes.${key}`);
        if (targetAppName) {
            const path = config(`ui.${targetAppName}.routes.${key}`);
            if (isRelative) {
                let returnedPath = `/${path}`;
                const appHref = getAppHref(targetAppName);
                if (appHref) {
                    const appUrl = new URL(appHref);
                    returnedPath = `${appUrl.pathname}/${path}`;
                }
                return returnedPath.replace("//", "/");
            }
            const appHref = getAppHref(targetAppName);
            if (path && appHref) {
                const appUrl = new URL(appHref);
                appUrl.pathname = `${appUrl.pathname}/${path}`.replace("//", "/");
                return appUrl.toString();
            }
        }
        return null;
    };
    return {
        config,
        getApiBase,
        getAppHref,
        getAppHrefByProductCode,
        getProductCodeByHref,
        getRoute,
    };
};
exports.default = createConfig;
//# sourceMappingURL=createConfig.js.map